import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { GoogleReviews } from '../components/GoogleReviews';
import { Heart, Shield, Sparkles, Users, ArrowRight, HeartHandshake, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function AboutPage() {
  const {
    t,
    lang
  } = useTranslation();
  const values = [{
    icon: Heart,
    title: t('about.values.patientCare.title'),
    desc: t('about.values.patientCare.desc')
  }, {
    icon: Shield,
    title: t('about.values.trust.title'),
    desc: t('about.values.trust.desc')
  }, {
    icon: lang === 'en' ? Sparkles : HeartHandshake,
    title: t('about.values.nativeLanguage.title'),
    desc: t('about.values.nativeLanguage.desc')
  }, {
    icon: Users,
    title: t('about.values.expertTeam.title'),
    desc: t('about.values.expertTeam.desc')
  }];
  return <Layout data-id="element-129">
      {/* Hero */}
      <section className="bg-teal-900 text-white py-20" data-id="element-130">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-131">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-132">
            {t('about.title')}
          </h1>
          <p className="text-xl text-teal-100 max-w-2xl mx-auto" data-id="element-133">
            {t('about.subtitle')}
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white" data-id="element-134">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-136">
            <div className="relative" data-id="element-137">
              <div className="absolute inset-0 bg-teal-100 rounded-3xl transform -rotate-3" data-id="element-138"></div>
              <img src="https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Our Clinic" className="relative rounded-3xl shadow-xl w-full h-[500px] object-cover" data-id="element-139" />
            </div>
            <div className="space-y-6" data-id="element-140">
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-141">
                {t('about.storyTitle')}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-142">
                {t('about.storyP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-143">
                {t('about.storyP2')}
              </p>
              <div className="pt-4" data-id="element-144">
                <Link to={`/${lang}/contact`} data-id="element-145">
                  <Button size="lg" className="gap-2" data-id="element-146">
                    {t('about.meetTeam')} <ArrowRight className="w-4 h-4" data-id="element-147" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50" data-id="element-148">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
          <div className="text-center mb-16" data-id="element-150">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-151">
              {t('about.valuesTitle')}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-152">
              {t('about.valuesSubtitle')}
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-153">
            {values.map((value, idx) => <Card key={idx} className="p-8 text-center" data-id="element-154">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center text-teal-600 mx-auto mb-6" data-id="element-155">
                  <value.icon className="w-6 h-6" data-id="element-156" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-157">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-158">{value.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Reviews */}
      <GoogleReviews data-id="element-159" />

      {/* CTA */}
      <section className="py-20 bg-white" data-id="element-160">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-161">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-162">
            {t('about.ctaTitle')}
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-163">{t('about.ctaSubtitle')}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-164">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-165">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-166">
                <Calendar className="w-5 h-5" data-id="element-167" />
                {t('nav.bookOnline')}
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-168">
              <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-169">
                {t('nav.contact')}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}